module.exports = __webpack_public_path__ + "img/measurement_info_back_neck_left.7fec9832.jpg";